module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Ways")]), _vm._v(" "), _c('th', [_vm._v("Sites")]), _vm._v(" "), _c('th', [_vm._v("Percent")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sharing), function(s, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(_vm.formatInteger(i + 1)))]), _vm._v(" "), _c('td', [_c('org-badge', {
      attrs: {
        "short-name": s.sharer,
        "color": s.colourCode
      }
    })], 1), _vm._v(" "), _c('td', [_c('b', {
      class: _vm.colorWays(s.ways)
    }, [_vm._v(_vm._s(_vm.formatInteger(s.ways)))])]), _vm._v(" "), _c('td', [_c('b', {
      staticClass: "text-black"
    }, [_vm._v(_vm._s(_vm.formatInteger(s.sites)))])]), _vm._v(" "), _c('td', [_c('i', [_vm._v(_vm._s(_vm.formatNumber(s.percent, 2)) + "%")])]), _vm._v(" "), _c('br')])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4412162a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sharers/SharerWaysReport.vue
// module id = 1450
// module chunks = 0